import React from "react";

import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/svg/keyboard_arrow_left.svg";
import { ReactComponent as WarningIcon } from "../../../../assets/svg/warning_green.svg";
import { ReactComponent as RightArrowIcon } from "../../../../assets/svg/arrow_right.svg";
import { ITeachingHintsIntroductions } from "../../../../state";

import styles from "./Introduction.module.scss";

type Props = {
  onClose: () => void;
  onBack: () => void;
  onNavigateToSurvey?: () => void;
  teachingHints: ITeachingHintsIntroductions | null;
};

const TAB_HINT_TYPES = ["interests", "events", "subjects"] as const;

const Introduction: React.FC<Props> = ({
  onClose,
  onBack,
  teachingHints,
  onNavigateToSurvey,
}) => {
  const [tab, setTab] = React.useState(0);

  const selectedHintType = TAB_HINT_TYPES[tab];

  const selectedHints = React.useMemo(() => {
    return teachingHints?.hints.filter(
      hint => hint.hint_type === selectedHintType,
    );
  }, [teachingHints, selectedHintType]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.leftPortion}>
          <button onClick={onBack}>
            <ArrowLeft />
          </button>
          <h1 className={styles.headerText}>
            導入トークのアイデアを考えてみたよ！
          </h1>
        </div>
        <button className={styles.closeButton}>
          <CloseIcon onClick={onClose} />
        </button>
      </div>

      <div className={styles.content}>
        {/*固定文で運用することになったが、後ほど各lessonごとに動的に変わる想定とのことでレスポンスからの取得は残しておく*/}
        {/*<p>{teachingHints?.introduction_explanation}</p>*/}
        <p>
          生徒がLesson内容を自分ごととして考えたり、興味を持つための具体例のアイデアを提案するよ。
          <br />
          授業の冒頭でLesson内容を伝えるときや、WORKのイメージをつけてほしいときに話してみてね。
        </p>

        <div className={styles.tabs}>
          <div
            className={`${styles.tab} ${
              tab === TAB_HINT_TYPES.indexOf("interests")
                ? styles.activeTab
                : ""
            }`}
            onClick={() => setTab(TAB_HINT_TYPES.indexOf("interests"))}
          >
            PICOの「これ知ってる？」
            <div className={styles.tab__tail} />
          </div>
          <div
            className={`${styles.tab} ${
              tab === TAB_HINT_TYPES.indexOf("events") ? styles.activeTab : ""
            }`}
            onClick={() => setTab(TAB_HINT_TYPES.indexOf("events"))}
          >
            今年度のイベント
            <div className={styles.tab__tail} />
          </div>
          <div
            className={`${styles.tab} ${
              tab === TAB_HINT_TYPES.indexOf("subjects") ? styles.activeTab : ""
            }`}
            onClick={() => setTab(TAB_HINT_TYPES.indexOf("subjects"))}
          >
            担当教科
            <div className={styles.tab__tail} />
          </div>
        </div>

        {selectedHints &&
        selectedHints.length > 0 &&
        selectedHints.some(hint => hint.theme && hint.content) ? (
          selectedHints
            .filter(hint => hint.theme && hint.content)
            .map((selectedHint, index) => (
              <div
                className={styles.dynamicContent}
                key={selectedHint.id + index}
              >
                <div className={styles.header}>
                  <div className={styles.headerText}>{selectedHint.theme}</div>
                </div>
                <div className={styles.dynamicBody}>{selectedHint.content}</div>
              </div>
            ))
        ) : (
          <div className={styles.dynamicContent}>
            <div className={styles.warning}>
              <WarningIcon />
              まだヒントがありません
            </div>
          </div>
        )}

        <div className={styles.footer}>
          {selectedHints &&
          selectedHints.length > 0 &&
          selectedHints.some(hint => hint.theme && hint.content)
            ? "ぼくのヒントも参考にしながら、生徒のみんなが興味を持ってくれるような導入を先生の言葉で伝えてみてね！\n" +
              "(AIの特性上、時々間違ったことを言っちゃうかも…。だから、伝える前に内容を確認してもらえると嬉しいな！)"
            : ""}
          {(!selectedHints ||
            selectedHints.length === 0 ||
            !selectedHints.some(hint => hint.theme && hint.content)) && (
            <div className={styles.buttonContainer}>
              <button onClick={onNavigateToSurvey}>
                最新の情報を入力してヒントを生成する <RightArrowIcon />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Introduction;
